import * as s from "./Loading.css"

type Props = {}

function Loading({}: Props) {
  return <div className={s.loading} />
}

export default Loading
// export type { Props as LoadingProps }
